<div id="menu" *ngIf="mandant">
    <div id="menu_header">
        <div id="toolbar-navigation">
            <a class="aLinks" tabindex="0" (click)="setLinkInactive(1); home_link()" *ngIf="home_config()" [class.router-link-active]="router.url.includes('/home')"
               routerLinkActive="router-link-active">
              <mat-icon id="homeIcon">home</mat-icon>
              <span *ngIf="beschriftung">Home</span>
            </a>

            <webToolbarPubSplan class="pubSpeiseplan" *ngIf="!kunde && this.mandant.navigation_root.menu" [mandant]="mandant" [beschriftung]="beschriftung"></webToolbarPubSplan>

            <a *ngIf="kunde && kunde.rollen.indexOf('menuevorauswaehler') > -1" (click)="setLinkInactive(2)" [routerLink]="'/menu-vorauswahl'"
               routerLinkActive="router-link-active"><mat-icon>restaurant</mat-icon><span>Menüvorauswahl</span></a>

            <ng-container *ngIf="kunde && kunde.rollen.indexOf('menuevorauswaehler') == -1">
                <a (click)="setLinkInactive(2)" [routerLink]="'/speiseplan-kunde'" class="aLinks" tabindex="0"
                   routerLinkActive="router-link-active">
                  <mat-icon>restaurant</mat-icon>
                  <span *ngIf="beschriftung">Speiseplan</span>
                </a>
                <a (click)="setLinkInactive(2)" [routerLink]="'/warenkorb'" class="aLinks" tabindex="0"  routerLinkActive="router-link-active"
                   [class.heartbeat]="this.bestell_service._bestellungen_meta.anzahl > 0 ? this.bestell_service._bestellungen_meta.anzahl : null"
                ><mat-icon>shopping_cart</mat-icon>
                  <span *ngIf="beschriftung" [matBadge]="this.bestell_service._bestellungen_meta.anzahl > 0 ? this.bestell_service._bestellungen_meta.anzahl : null" matBadgeSize="small">Warenkorb</span>
                </a>
                <a (click)="setLinkInactive(2)" [routerLink]="'/bestellhistorie'" class="aLinks" tabindex="0"
                   routerLinkActive="router-link-active"><mat-icon>date_range</mat-icon><span *ngIf="beschriftung">Bestellhistorie</span></a>
            </ng-container>
            <!--      <a *ngIf="kunde && kunde.sammelbesteller" (click)="setLinkInactive(2)" [routerLink]="'/sammelbesteller'"-->
            <!--         routerLinkActive="router-link-active"><mat-icon>menu_book</mat-icon>Sammelbesteller</a>-->
        </div>
    </div>

    <div *ngIf="!kunde" id="anmelden">
        <mitteilungen-icon class="mitteilungen" [kunde]="kunde" [beschriftung]="beschriftung"></mitteilungen-icon>
      <a tabindex="0" class="farbkatalog aLinks" (click)="toggleSidebar()" (keydown.enter)="toggleSidebar()" *ngIf="farbkatalogAktiv()"><mat-icon>palette</mat-icon><span *ngIf="beschriftung">Farbkatalog</span></a>
        <a tabindex="0" class="aLinks" *ngIf="!kunde && (mandant.registrierFormen | json) != '{}' && registerButton" (click)="setLinkInactive(2)" [routerLink]="registrationLink()"
           routerLinkActive="router-link-active"><mat-icon>app_registration</mat-icon><span *ngIf="beschriftung">Registrieren</span></a>
        <a tabindex="0" class="aLinks" *ngIf="!kunde" [routerLink]="'/login'" routerLinkActive="router-link-active"><mat-icon>login</mat-icon><span *ngIf="beschriftung">Anmelden</span></a>
    </div>


    <div class="toolbar-profildiv" *ngIf="kunde">
        <expressStorno-icon *ngIf="kunde.rollen.indexOf('menuevorauswaehler') == -1" [kunde]="kunde" [mandant]="mandant" [beschriftung]="beschriftung"></expressStorno-icon>
        <mitteilungen-icon class="mitteilungen" [beschriftung]="beschriftung" id="mitteilungen"></mitteilungen-icon>
        <a tabindex="0" class="farbkatalog aLinks" (click)="toggleSidebar()" (keydown.enter)="toggleSidebar()" *ngIf="farbkatalogAktiv()"><mat-icon>palette</mat-icon><span *ngIf="beschriftung">Farbkatalog</span></a>
        <div class="guthaben" *ngIf="guthaben">
            <mat-icon>savings</mat-icon>
            <span>{{ guthaben | euroPrice }}€</span>
        </div>
        <a *ngIf="mandantId == '104890-aubg-kita'
    || mandantId == '104890-aubg-frisch'
    || mandantId == '104890-aubg-schule'
    || mandantId == 'rcsjg'
    || mandantId == 'rcsls'" [routerLink]="'/rechtliches'" [queryParams]="{id: 'faq', entry:'Guthaben aufladen'}"
           routerLinkActive="router-link-active" tabindex="0" class="aLinks"><mat-icon>savings</mat-icon><span *ngIf="beschriftung">Guthaben aufladen</span></a>
        <div id="toolbar-addsavings" *ngIf="kunde">
            <button
                [matMenuTriggerFor]="profil"
                id="profil"
                class="profil-button"
                [ngClass]="{ 'router-link-active': isProfileActive }">
                <div id="profilButtonTrigger">
                    <span id="profilSpan">{{ kunde.essensteilnehmer.vorname }} {{kunde.essensteilnehmer.name}}</span>
                    <mat-icon>arrow_drop_down</mat-icon>
                </div>
            </button>

            <mat-menu #profil="matMenu" class="profilMenu" #benutzerMenu>
                <a mat-menu-item
                   [routerLink]="'/profil'"
                   [queryParams]="{id: 'einsehen'}"
                   tabindex="0"
                   (click)="setLinkActive(2)"
                   (click)="setLinkInactive(2)"
                   class="profil-button">
                    <mat-icon>people</mat-icon>
                    <span>Benutzer bearbeiten</span>
                </a>
<!--                <a-->
<!--                    mat-menu-item-->
<!--                    [routerLink]="'/profil'"-->
<!--                    [queryParams]="{id: 'rechnungen'}"-->
<!--                    tabindex="0"-->
<!--                    (click)="setLinkActive(2)"-->
<!--                    (click)="setLinkInactive(2)"-->
<!--                    class="profil-button"-->
<!--                >-->
<!--                    <mat-icon>receipt_long</mat-icon>-->
<!--                    Rechnungen-->
<!--                </a>-->

                <a mat-menu-item
                   tabindex="0"
                   (keydown.enter)="logout(kunde.kundeId)"
                   (click)="logout(kunde.kundeId)"
                   class="profil-button">
                    <mat-icon>logout</mat-icon>
                    <span>Abmelden</span>
                </a>
            </mat-menu>
        </div>

    </div>
</div>
